import React from 'react'
import Terms from '../../../Terms'
import { useAppDispatch } from '../../../redux/hooks'
import { closeModal } from '../../../redux/slices/modalSlice'
import { ModalCssAnimation } from '../ModalManager'

const SplashModal: React.FC = () => {
	const dispatch = useAppDispatch()

	const handleAgree = () => {
		localStorage.setItem('agreedToTerms', 'true')
		dispatch(closeModal())
	}

	return (
		<div className={`splash-modal ${ModalCssAnimation}`}>
			<div className="splash-modal-image"></div>
			<div className="splash-modal-title">Welcome to Smartico’s Fake Casino Demo</div>
			<div className="close-btn" onClick={handleAgree}>
				Continue
			</div>
			<Terms />
		</div>
	)
}

export default SplashModal
